<template>
  <nav class="navbar">
    <div class="navbar-inner">
      <router-link to="/" class="navbar-brand">
        <img class="brand-logo" :src="require('@/assets/images/colorLogo.png')" alt="LOGO" />
      </router-link>

      <div class="navbar-links" :class="{ active: menuOpen }">
        <router-link to="/" class="nav-link" exact @click.native="menuOpen = false">首页</router-link>
        <router-link to="/gallery" class="nav-link" @click.native="menuOpen = false">灵感广场</router-link>
        <router-link to="/models" class="nav-link" @click.native="menuOpen = false">模型介绍</router-link>
        <router-link v-if="isLoggedIn" to="/history" class="nav-link" @click.native="menuOpen = false">生成记录</router-link>
      </div>

      <div class="navbar-right">
        <template v-if="isLoggedIn">
          <div class="balance-box">
            <span class="balance-label">余额：</span>
            <span class="balance-num">{{ credits }}</span>
          </div>
          <button class="btn-recharge" @click="$router.push('/credits')">充值</button>
          <div class="user-menu" @click="$router.push('/profile')">
            <div class="user-avatar">{{ userAvatar }}</div>
            <span class="user-name">我的</span>
          </div>
        </template>
        <template v-else>
          <span class="auth-link" @click="openAuthDialog('login')">登录</span>
          <span class="auth-divider">/</span>
          <span class="auth-link" @click="openAuthDialog('register')">注册</span>
        </template>
      </div>

      <div class="mobile-toggle" @click="menuOpen = !menuOpen">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path v-if="!menuOpen" d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path v-else d="M6 6l12 12M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NavBar',
  data() {
    return {
      menuOpen: false
    }
  },
  computed: {
    ...mapState(['user', 'credits', 'isLoggedIn']),
    userName() {
      if (this.user && this.user.user_metadata && this.user.user_metadata.full_name) {
        return this.user.user_metadata.full_name
      }
      if (this.user && this.user.email) {
        return this.user.email.split('@')[0]
      }
      return '用户'
    },
    userAvatar() {
      return this.userName.charAt(0).toUpperCase()
    }
  },
  methods: {
    openAuthDialog(mode) {
      this.$store.commit('SET_AUTH_DIALOG', { show: true, mode: mode || 'login' })
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: rgba(10, 10, 15, 0.9);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border);
  z-index: 1000;
}

.navbar-inner {
  max-width: 1600px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: #fff;
}

.brand-logo {
  max-width: 154px;
  height: auto;
  display: block;
}

.navbar-links {
  display: flex;
  align-items: center;
  gap: 32px;
}

.nav-link {
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
  position: relative;
  padding: 4px 0;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #fff;
}

.nav-link.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  /* background: var(--accent); */
  border-radius: 1px;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.balance-box {
  font-size: 14px;
  color: var(--text-secondary);
}

.balance-num {
  color: var(--text-primary);
  font-weight: 600;
}

.btn-recharge {
  padding: 5px 14px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
}

.btn-recharge:hover {
  background: var(--accent-hover);
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bg-hover);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}

.user-name {
  font-size: 14px;
  color: var(--text-secondary);
}

.auth-link {
  font-size: 14px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: var(--transition);
}

.auth-link:hover {
  color: #fff;
}

.auth-divider {
  color: var(--text-muted);
  font-size: 14px;
}

.mobile-toggle {
  display: none;
  cursor: pointer;
  color: #fff;
  padding: 4px;
}

@media (max-width: 768px) {
  .navbar-links {
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    background: rgba(10, 10, 15, 0.98);
    backdrop-filter: blur(20px);
    flex-direction: column;
    padding: 20px;
    gap: 16px;
    border-bottom: 1px solid var(--border);
    display: none;
  }

  .navbar-links.active {
    display: flex;
  }

  .mobile-toggle {
    display: block;
  }

  .user-name,
  .balance-box {
    display: none;
  }
}
</style>
